import { FC, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { ArticleTemplate } from "../../models/responses/articleTemplate";
import { Col, Row, Spinner } from "react-bootstrap";
import { Eye, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { getArticleTemplates } from "../../app/services/articleTemplateService";
import { ArticleType } from "../../models/enums/articleTypeEnum";

interface Props {}

const ArticleTemplates: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const articleTemplates: ArticleTemplate[] = useSelector(
    (state: RootState) => state.articleTemplate.articleTemplateList || []
  );
  const loadingArticleTemplates = useSelector(
    (state: RootState) => state.articleTemplate.isWaitingArticleTemplateGetResponse
  );
  
  useEffect(() => {
    dispatch(getArticleTemplates(instance, account));
  }, [account, accounts, dispatch, instance]);

  const openArticleTemplateHandler = (articleTemplate: ArticleTemplate) => {
    navigate(`/admin/article-templates/${articleTemplate.id}`, { relative: "path" });
  };

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <h1>Artikelmallar</h1>
        </Col>
        <Col className="text-end">
          <Button
            className="mt-2 ms-2"
            variant="outline-primary"
            href={`/admin/article-templates/add`}
          >
            Lägg till <Plus />
          </Button>
        </Col>
      </Row>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Artikelnummer</th>
            <th>Beskrivning</th>
            <th>Pris</th>
            <th>Använd ursprungligt pris</th>
            <th>Typ</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {articleTemplates.map((articleTemplate) => (
            <tr
              key={articleTemplate.id}
              role="button"
              onClick={() => openArticleTemplateHandler(articleTemplate)}
            >
              <td>{articleTemplate.articleNumber}</td>
              <td>{articleTemplate.description}</td>
              <td>{articleTemplate.salesPrice}</td>
              <td>{articleTemplate.keepIncomingPrice ? "Ja" : "Nej"}</td>
              <td>{ArticleType[articleTemplate.articleType as ArticleType]}</td>
              <td align="center"><Eye /></td>
            </tr>
          ))}
        </tbody>
      </Table>

      {loadingArticleTemplates && (
        <>
          <Row className="mb-3">
            <Col className="text-center">
              <Spinner variant="primary" />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ArticleTemplates;
